var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-custom valign-center flex-center"},[_c('span',[_vm._v(_vm._s(_vm.$t('themeCustom.message.test')))]),_c('el-color-picker',{on:{"change":_vm.onColorChange},model:{value:(_vm.newColor),callback:function ($$v) {_vm.newColor=$$v},expression:"newColor"}}),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("主题颜色")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }